import {CommonModule} from '@angular/common';
import {Component, Input, ViewChild} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CustomFieldsFormComponent} from '@q9elements/ui-kit/changes/shared';
import {CustomField, CustomFieldType, Q9HtmlDecoderPipe} from '@q9elements/ui-kit/common';
import {
  ChipsSelectComponent,
  DatetimePickerComponent,
  RichTextFieldComponent,
  SelectModule,
  TextFieldComponent
} from '@q9elements/ui-kit/components';

import {CheckboxWrapperComponent} from '../checkbox-wrapper/checkbox-wrapper.component';

@Component({
  selector: 'q9ma-bulk-custom-fields-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextFieldComponent,
    RichTextFieldComponent,
    ChipsSelectComponent,
    DatetimePickerComponent,
    SelectModule,
    Q9HtmlDecoderPipe,
    CheckboxWrapperComponent
  ],
  templateUrl: './bulk-custom-fields-form.component.html',
  styleUrls: ['./bulk-custom-fields-form.component.scss']
})
export class BulkCustomFieldsFormComponent extends CustomFieldsFormComponent {
  @Input() isPreview: boolean;

  @ViewChild(ChipsSelectComponent) public chipsSelect: ChipsSelectComponent;

  protected override setFields(fields: CustomField[]) {
    const filteredFields = fields.filter(field =>
      [CustomFieldType.List, CustomFieldType.TagList].includes(field.properties.type)
    );

    super.setFields(filteredFields);
  }
}
